import { TableStatsHistogram } from '@/lib/types/TableStatsHistogram';

export interface HistogramData {
  name: number;
  value: number;
}

export function transformData(data?: TableStatsHistogram): HistogramData[] {
  if (!data || data[0].length === 0 || data[1].length === 0) {
    return [];
  }

  const lengths = data[0];
  const counts = data[1];

  // Create an array of objects with 'length' and 'count' properties
  const transformedData = lengths.map((length, index) => ({
    name: length,
    value: counts[index],
  }));

  return transformedData;
}
